export default theme => ({
  loaderContainer: {
    height: '100%',
    maxHeight: '500px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingBottom: 40
  },
  autocompleteContainer: {
    minHeight: 52,
    display: 'flex',
    alignItems: 'center',
    '& .MuiAutocomplete-root': {
      flex: 1,
      '& .MuiFormHelperText-root': {
        marginBottom: -24
      }
    }
  },
  selectAllButton: {
    marginLeft: theme.spacing(1)
  },
  mainKgRow: {
    // Works by interpolating the background color with black
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      // !important is necessary to give it preference over the default hover color
      // The color is the same as when not hovering, as the row is not selectable
      backgroundColor: 'rgba(0, 0, 0, 0.08) !important'
    }
  }
});
